export default "__VITE_ASSET__v45UtHXu__"